var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-grm-comp": "RoomCBTLogList" } },
    [
      _c("table", [
        _vm._m(0),
        _vm._m(1),
        _c(
          "tbody",
          [
            _vm._l(_vm.cbtLogList, function (roomCBT) {
              return _c("tr", { key: roomCBT.roomCbtId }, [
                _c("td", [_vm._v(_vm._s(roomCBT.roomCbtTitle))]),
                _c("td", [_vm._v(_vm._s(roomCBT.cbt.questionList.length))]),
                _c("td", [_vm._v(_vm._s(roomCBT.roomCbtUserCnt))]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.dayjs(roomCBT.beginDate).format("YYYY-MM-DD HH:mm:ss")
                    ) +
                      " ~ " +
                      _vm._s(
                        _vm.dayjs(roomCBT.endDate).format("YYYY-MM-DD HH:mm:ss")
                      )
                  ),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.duration(roomCBT.duration)))]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "flex justify-center items-center gap-1" },
                    [
                      _c(
                        "GrmBtn",
                        {
                          attrs: { size: "xs" },
                          on: {
                            click: function ($event) {
                              return _vm.onSelectCBT(roomCBT)
                            },
                          },
                        },
                        [_vm._v("상세보기")]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            }),
            _vm.cbtLogList.length === 0
              ? _c("tr", [
                  _c("td", { attrs: { colspan: "6" } }, [
                    _vm._v("출제 이력이 없습니다."),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("GrmPagination", {
        staticClass: "mt-3",
        attrs: { "page-info": _vm.cbtLogListPageInfo },
        on: { paging: _vm.onChangePage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "16%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "6%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("제목")]),
        _c("th", [_vm._v("문항 수")]),
        _c("th", [_vm._v("응시자 수")]),
        _c("th", [_vm._v("출제 기간")]),
        _c("th", [_vm._v("제한 시간")]),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }